export default "__VITE_ASSET__iCBiGJ0x__"